/* ============================================================
   Flower Station Dubai — wedding-consult.js
   Multi-step wedding enquiry wizard. Vanilla IIFE (no deps).
   Pairs with sections/wedding-consult.liquid + assets/component-consultation.css
   (shared shell with the preservation wizard). Slimmed: step nav + validation +
   Turnstile + a single JSON POST. No option cards / conditionals / file upload.
   ============================================================ */
(function () {
  var root = document.querySelector('[data-pconsult]');
  if (!root) return;

  var form      = root.querySelector('[data-pc-form]');
  var panels    = Array.prototype.slice.call(root.querySelectorAll('.pconsult__panel'));
  var progress  = Array.prototype.slice.call(root.querySelectorAll('[data-progress-step]'));
  var bar       = root.querySelector('[data-bar]');
  var curNum    = root.querySelector('[data-cur]');
  var curLabel  = root.querySelector('[data-cur-label]');
  var backBtn   = root.querySelector('[data-back]');
  var nextBtn   = root.querySelector('[data-next]');
  var submitBtn = root.querySelector('[data-submit]');
  var successEl = root.querySelector('[data-success]');
  var body      = root.querySelector('.pconsult__body');
  var nav       = root.querySelector('.pconsult__nav');

  var API      = (root.getAttribute('data-api') || '').replace(/\/+$/, '');
  var ENDPOINT = root.getAttribute('data-endpoint') || '/api/v1/wedding-request';
  var ID_PREFIX = root.getAttribute('data-id-prefix') || 'WD';
  var TS_KEY   = root.getAttribute('data-turnstile') || '';

  var total   = panels.length;
  var current = 1;
  var tsWidget = null;
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function toast(msg, kind) {
    if (window.FSToast && typeof window.FSToast.show === 'function') window.FSToast.show(msg, kind || 'error');
  }
  function panelFor(step) { return panels[step - 1]; }

  /* ── progress ── */
  function paint() {
    progress.forEach(function (li) {
      var n = parseInt(li.getAttribute('data-progress-step'), 10);
      li.classList.toggle('is-done', n < current);
      li.classList.toggle('is-active', n === current);
    });
    if (bar) bar.style.width = Math.round((current / total) * 100) + '%';
    if (curNum) curNum.textContent = current;
    if (curLabel) {
      var t = panelFor(current).querySelector('.pconsult__step-title');
      curLabel.textContent = t ? t.textContent.trim() : '';
    }
    if (backBtn) backBtn.hidden = current === 1;
    var last = current === total;
    if (nextBtn) nextBtn.hidden = last;
    if (submitBtn) submitBtn.hidden = !last;
  }
  function goTo(step) {
    current = Math.max(1, Math.min(total, step));
    panels.forEach(function (p, i) { p.classList.toggle('is-active', i === current - 1); });
    paint();
    if (current === total) mountTurnstile();
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    var focusable = panelFor(current).querySelector('select,input,textarea,button,[tabindex]');
    if (focusable) { try { focusable.focus({ preventScroll: true }); } catch (e) { focusable.focus(); } }
  }

  /* ── option pills (single + multi) ── */
  root.querySelectorAll('[data-pills]').forEach(function (group) {
    var multi = group.hasAttribute('data-multi');
    group.addEventListener('click', function (e) {
      var pill = e.target.closest('.opt-pill');
      if (!pill) return;
      if (multi) {
        var on = pill.classList.toggle('is-active');
        pill.setAttribute('aria-pressed', on ? 'true' : 'false');
      } else {
        group.querySelectorAll('.opt-pill').forEach(function (p) {
          var s = p === pill;
          p.classList.toggle('is-active', s);
          p.setAttribute('aria-pressed', s ? 'true' : 'false');
        });
      }
    });
  });
  function collectPills(group) {
    var vals = [];
    group.querySelectorAll('.opt-pill.is-active').forEach(function (p) { vals.push(p.getAttribute('data-value')); });
    return vals;
  }

  /* ── Turnstile (lazy, on the final step) ── */
  function mountTurnstile() {
    if (!TS_KEY) return;
    var holder = root.querySelector('[data-turnstile-holder]');
    if (!holder || tsWidget !== null) return;
    if (!window.turnstile) { setTimeout(mountTurnstile, 300); return; }
    tsWidget = window.turnstile.render(holder, { sitekey: TS_KEY });
  }
  function turnstileToken() {
    if (!TS_KEY) return '';
    if (window.turnstile && tsWidget !== null) return window.turnstile.getResponse(tsWidget) || '';
    return '';
  }
  function turnstileReset() {
    if (window.turnstile && tsWidget !== null) window.turnstile.reset(tsWidget);
  }

  /* ── validation ── */
  function validate(step) {
    var panel = panelFor(step);
    panel.querySelectorAll('.is-error').forEach(function (el) { el.classList.remove('is-error'); });

    var first = null, badEmail = false, uncheck = false, missingPick = false;

    // Required inputs / selects / checkboxes
    panel.querySelectorAll('[data-required]').forEach(function (el) {
      if (el.hasAttribute('data-pills')) return; // handled below
      var bad = false;
      if (el.hasAttribute('data-checkbox')) {
        bad = !el.checked;
        if (bad) uncheck = true;
      } else if (el.getAttribute('data-type') === 'email') {
        bad = !EMAIL.test((el.value || '').trim());
        if (bad && (el.value || '').trim()) badEmail = true;
      } else {
        bad = !(el.value || '').trim();
      }
      if (bad) {
        if (el.classList.contains('field__input') || el.classList.contains('field__select')) el.classList.add('is-error');
        if (!first) first = el;
      }
    });

    // Required pill groups (≥1 selection)
    panel.querySelectorAll('[data-pills][data-required]').forEach(function (g) {
      if (g.querySelectorAll('.opt-pill.is-active').length === 0) {
        missingPick = true;
        if (!first) first = g.querySelector('.opt-pill');
      }
    });

    if (step === total && TS_KEY && !turnstileToken()) {
      toast('Please complete the verification check.');
      return false;
    }

    if (first) {
      var msg = badEmail ? 'Please enter a valid email address.'
              : uncheck ? 'Please tick the required box to continue.'
              : missingPick ? 'Please make all required selections to continue.'
              : 'Please complete the required fields.';
      toast(msg);
      try { first.focus({ preventScroll: false }); } catch (e) { if (first.focus) first.focus(); }
      return false;
    }
    return true;
  }

  /* ── collect ── */
  function collect() {
    var data = {};
    form.querySelectorAll('[name]').forEach(function (el) {
      if (el.type === 'checkbox') { data[el.name] = el.checked; return; }
      data[el.name] = (el.value || '').trim();
    });
    root.querySelectorAll('[data-pills]').forEach(function (g) {
      var name = g.getAttribute('data-name');
      var vals = collectPills(g);
      data[name] = g.hasAttribute('data-multi') ? vals : (vals[0] || '');
    });
    return data;
  }

  /* ── submit ── */
  function postJSON(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (json) {
        if (!r.ok) throw new Error(json && json.error ? json.error : 'Request failed (' + r.status + ')');
        return json;
      });
    });
  }
  function loading(on) {
    submitBtn.classList.toggle('btn--loading', on);
    submitBtn.disabled = on;
    if (backBtn) backBtn.disabled = on;
  }
  function demoId() {
    var d = new Date();
    var ymd = '' + d.getFullYear() + ('0' + (d.getMonth() + 1)).slice(-2) + ('0' + d.getDate()).slice(-2);
    return ID_PREFIX + '-' + ymd + '-' + String(Date.now()).slice(-6);
  }
  function finish(id) {
    var idEl = root.querySelector('[data-project-id]');
    if (idEl) idEl.textContent = id || '—';
    if (body) body.style.display = 'none';
    if (nav) nav.style.display = 'none';
    var pf = root.querySelector('.pconsult__progress'); if (pf) pf.style.display = 'none';
    var pm = root.querySelector('.pconsult__progress-mini'); if (pm) pm.style.display = 'none';
    if (successEl) successEl.classList.add('is-active');
    if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function submit() {
    if (!validate(total)) return;
    loading(true);
    var payload = collect();
    payload.turnstile = turnstileToken();

    if (!API) { setTimeout(function () { finish(demoId()); }, 650); return; }

    postJSON(API + ENDPOINT, payload)
      .then(function (res) { finish(res && res.requestId); })
      .catch(function (err) {
        loading(false);
        turnstileReset();
        toast((err && err.message) || 'Submission failed. Please try again.');
      });
  }

  /* ── nav wiring ── */
  if (nextBtn) nextBtn.addEventListener('click', function () { if (validate(current)) goTo(current + 1); });
  if (backBtn) backBtn.addEventListener('click', function () { goTo(current - 1); });
  if (form) form.addEventListener('submit', function (e) { e.preventDefault(); submit(); });

  paint();
})();
